module.exports = __webpack_public_path__ + "static/img/6.2f1d0bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/7/6.png
// module id = fGj7
// module chunks = 0